const shadows = {
    innerInputElementShadow: "0 0 2px #ddd",
    containerInputElementShadow: "0 0 3px #ccc",
}
export default shadows